import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import CtaStyle2 from '../Cta/CtaStyle2';
import PricingTableList from '../PricingTable/PricingTableList';
import SectionHeading from '../SectionHeading';
import AboutStyle6 from '../About/AboutStyle6';
import CardStyle3 from '../Card/CardStyle3';
import { pageTitle } from '../../helpers/PageTitle';

export default function SiteAssessmentsEnergyAuditsPage() {
  pageTitle('Sites Assessments and Energy Audits');

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Empowering Sustainable Energy Solutions"
        subTitle="Site Assessments & Energy Audits"
        shape="shape_3"
      />
      <Spacing lg="75" md="60" />
      <div className="cs_service_info">
        <div className="container">
          <div className="row align-items-center cs_gap_y_40">
            <div className="col-lg-6">
              <div
                className="cs_service_info_thumb cs_bg_filed"
                style={{
                  backgroundImage: 'url("/images/site-assessments/site-assessments-1.jpg")',
                }}
              />
            </div>
            <div className="col-lg-6">
              <div className="row cs_gap_y_40">
                <div className="col-sm-6">
                  <CardStyle3
                    number="01"
                    title="Detailed Site Evaluations"
                    subTitle="Our experts perform detailed site evaluations to determine the most effective renewable energy solutions tailored to your specific geographical and structural conditions."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="02"
                    title="Energy Consumption Audits"
                    subTitle="We conduct comprehensive energy audits to assess your current energy consumption and identify opportunities for efficiency improvements through renewable technologies."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="03"
                    title="Financial Analysis"
                    subTitle="Receive a detailed breakdown of the costs, savings, and return on investment associated with implementing renewable energy solutions at your site."
                  />
                </div>
                <div className="col-sm-6">
                  <CardStyle3
                    number="04"
                    title="Implementation Strategies"
                    subTitle="We provide customized implementation strategies that ensure the smooth integration of renewable energy systems into your existing infrastructure."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
      <AboutStyle6
        thumbnailSrc="/images/site-assessments/site-assessments-2.jpg"
        title="Maximize Your Energy Efficiency"
        subTitle="Harness the Power of Renewable Energy"
        featureList={[
          'Customized Energy Solutions',
          'Expert Installation and Maintenance',
          'Significant Cost Savings',
          'Sustainable and Eco-friendly Practices',
        ]}
        btnText="Explore Our Projects"
        btnUrl="/portfolio"
      />
      <Spacing lg="150" md="80" />
      <section className="cs_gray_bg_2 cs_shape_animation_2">
        <div className="container">
          <SectionHeading
            title="Transparent and Competitive Pricing"
            subTitle="Our Pricing"
          />
          <Spacing lg="85" md="45" />
          <PricingTableList />
        </div>
        <Spacing lg="150" md="80" />
      </section>
      <Spacing lg="140" md="70" />
      <CtaStyle2
        title="Ready to Optimize Your Energy Use?"
        btnText="Get Started"
        btnUrl="/contact"
      />
      <Spacing lg="150" md="80" />
    </>
  );
}
